import { useAuth } from "../contexts/AuthProvider/AuthProvider";

export const useLoggedInUserInfo = () => {
  const userInfo = useAuth().user;
  return userInfo;
};
